/**
 * Org-admin access predicate — the single client-side mirror of the server's
 * `require_org_admin` (apps/api/deps.py).
 *
 * Lives in `lib/` rather than a hook module because both a client hook
 * (`useOrgAdminGate`) and a React Server Component (the org-workspace route
 * group's layout) need the same decision, and the server one cannot import
 * from a `'use client'` module.
 *
 * The server stays authoritative: every gate built on this is about not
 * rendering a doomed request or a dead link, never about access control.
 */

/** Whether the active membership grants org-admin access. */
export function orgAdminAllowed(role: string | null | undefined): boolean {
  return role === 'org:admin'
}
